import {
    PIPE_STOCK_REPORT_REQUEST,
    PIPE_STOCK_REPORT_SUCCESS,
    PIPE_STOCK_REPORT_FAILURE,
    PIPE_STOCK_FILTER_REPORT_REQUEST,
    PIPE_STOCK_FILTER_REPORT_SUCCESS,
    PIPE_STOCK_FILTER_REPORT_FAILURE,
  } from "../types/pipe-stock-report-types";
  
  const initialState = {
    pipeStockReport: {},
    pipeStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const pipeStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PIPE_STOCK_REPORT_REQUEST: 
      case PIPE_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PIPE_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          pipeStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PIPE_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          pipeStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PIPE_STOCK_REPORT_FAILURE: 
      case PIPE_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default pipeStockReportReducer;
  